import { useTranslation } from "react-i18next";

import { ExternalReference } from "../trust/ExternalReference";
import { PRIVACY_CONTRACT, TRUST_LINKS } from "../trust/content";

export function PrivacyPage() {
  const { t } = useTranslation();
  const sections = ["device", "telemetry", "excluded", "links"] as const;
  return (
    <article className="page trust-page privacy-page">
      <header className="about-masthead"><div><span className="about-label">{t("privacy.title")}</span><h1>{t("privacy.title")}</h1></div><p>{t("privacy.intro", { version: PRIVACY_CONTRACT.version })}</p></header>
      <div className="about-grid">
        {sections.map((section) => (
          <section className="about-card" key={section}><h2>{t(`privacy.${section}Title`)}</h2><p>{t(`privacy.${section}Body`)}</p>{section === "links" ? <div className="about-primary-links"><ExternalReference href={TRUST_LINKS.githubIssues}>{t("about.issueTracker")}</ExternalReference></div> : null}</section>
        ))}
      </div>
    </article>
  );
}
